import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";

import { Frequency, TFrequency } from "src/app/types/CreateOrders";

const useFrequencyOptions = (
    optionsToUse: TFrequency[] = [
        Frequency.EVERYDAY,
        Frequency.EVERY_2_DAYS,
        Frequency.EVERY_3_DAYS,
        Frequency.ONE_BY_WEEK,
    ]
) => {
    const { formatMessage } = useIntl();
    const [frequencyOptions, setFrequencyOptions] = useState<Array<SimpleFormSelectOption>>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const frequencyListBuilder: Array<SimpleFormSelectOption> = [];
        for (const key in Frequency) {
            if (optionsToUse.includes(key as keyof typeof Frequency)) {
                frequencyListBuilder.push({
                    value: Frequency[key as keyof typeof Frequency],
                    label: formatMessage({
                        id: `common.field.frequency.${Frequency[key as keyof typeof Frequency]}`,
                    }),
                });
            }
        }
        setFrequencyOptions(frequencyListBuilder);
        setLoading(false);
    }, []);

    return { frequencyOptions, loading };
};

export default useFrequencyOptions;
